module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av441-1b81013285666b4e8c95c9fc91447b9e.jpg";